import React from "react";
import styled from "styled-components";
import {
  MobileOnlyWrapper,
  DesktopOnlyWrapper
} from "storybook-components/Wrapper";
import { H2Style } from "storybook-components/Typography";
import { CalendlyBtn } from "storybook-components/Button";
import { VerticalGutter, HorizontalGutter } from "./HeroGutterComponents";

const OuterGutterWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green5};
  ${props => props.theme.media.desktopUp`
    // required for placement under the nav
    margin-top: -81px;
    display: flex;
    background-color: ${({ theme }) => theme.colors.green3};
  `};
`;

const InnerSectionWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  background-color: ${({ theme }) => theme.colors.green5};
  width: 100%;
  ${props => props.theme.media.desktopUp`
    border-radius: 15px;
    margin: 20px;
  `};
`;

const CenterCopyGutterWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green3};
  margin: 0;
  border-radius: 15px;
  display: flex;
  width: 80%;
  ${props => props.theme.media.desktopUp`
    width: 785px;
    min-width: 785px;
    min-height: 350px;
  `};
`;

const CenterCopyInnerWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green1};
  margin: auto;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 20px;
  padding: 24px 0;
  ${props => props.theme.media.desktopUp`
    padding: 64px 0 40px;
  `};
`;

const PostTitle = styled.h1`
  ${H2Style};
  color: ${({ theme }) => theme.colors.green5};
  text-align: center;
  margin-top: 0;
  ${({ theme }) => theme.media.desktopUp`
    max-width: 60rem;
  `};
`;

const StlyedCalendlyButton = styled(CalendlyBtn)`
  text-align: center;
  margin: 0 auto;
  ${({ theme }) => theme.media.desktopUp`
  `};
`;

const BoxRow = styled.div`
  display: flex;
  height: ${props => (props.center ? "auto" : "120px")};
  width: 100%;
  ${props => props.theme.media.desktopUp`
    height: ${props => (props.center ? "auto" : "160px")};
  `};
`;

const Box = styled.div`
  background-color: transparent;
  height: ${props => props.height};
  width: ${props => props.width};
`;

export default ({ title, buttonTxt }) => {
  return (
    <OuterGutterWrapper>
      <InnerSectionWrapper>
        <BoxRow>
          <Box height="100%" width="35%" />
          <VerticalGutter upper />
          <Box height="100%" width="calc(20% - 60px)" />
          <DesktopOnlyWrapper>
            <VerticalGutter />
          </DesktopOnlyWrapper>
          <Box height="100%" width="45%" />
        </BoxRow>
        <BoxRow center>
          <HorizontalGutter
            width="calc((100% - 785px)/2)"
            mobileWidth="10%"
            marginTop="180px"
            left
          />
          <CenterCopyGutterWrapper>
            <CenterCopyInnerWrapper>
              <PostTitle>{title}</PostTitle>
              <StlyedCalendlyButton buttonType="ModulePrimary">
                {buttonTxt}
              </StlyedCalendlyButton>
            </CenterCopyInnerWrapper>
          </CenterCopyGutterWrapper>
          <HorizontalGutter
            width="calc((100% - 785px)/2)"
            mobileWidth="10%"
            marginTop="80px"
            right
          />
        </BoxRow>
        <BoxRow>
          <Box height="100%" width="calc(65% - 60px)" />
          <VerticalGutter lower />
          <Box height="100%" width="35%" />
        </BoxRow>
      </InnerSectionWrapper>
    </OuterGutterWrapper>
  );
};
